import React, { useRef, useState } from "react"
import styles from './Login.module.scss'
import { useAuth } from '../contexts/AuthContext';
import eventBus from "../utils/EventBus";
import ResetPassword from "./ResetPassword";

export default function ForgotPassword() {
    const emailRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { forgotPassword } = useAuth();

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const email = emailRef.current.value;
            const result = await forgotPassword(email);

            if (!result.success) {
                setError(result.error);
            } else {
                eventBus.publish('modal', {
                    title: "Reset your password",
                    content: <ResetPassword email={email} justSent/>
                })
            }
        } catch (err) {
            setError('Failed to send reset code');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className={styles.login}>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div>
                    <h3 className={styles.title}>Forgot password</h3>
                    {error && <div className={styles.error}>{error}</div>}
                    <p>Enter your account email and we'll send you a code to reset your password.</p>
                    <label>Email</label>
                    <input ref={emailRef} type="email" placeholder="Enter Email" required/>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Sending...' : 'Send reset code'}
                    </button>
                </div>
            </form>
        </div>
    )
}
